
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Search, Filter } from 'lucide-react'
import type { FilterStatus } from '../types'

interface ExtensionsFiltersProps {
  searchQuery: string
  setSearchQuery: (query: string) => void
  filterStatus: FilterStatus
  setFilterStatus: (status: FilterStatus) => void
  filterCategory: string
  setFilterCategory: (category: string) => void
  categories: string[]
}

export function ExtensionsFilters({
  searchQuery,
  setSearchQuery,
  filterStatus,
  setFilterStatus,
  filterCategory,
  setFilterCategory,
  categories,
}: ExtensionsFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-center bg-muted/40 p-1 rounded-lg border">
      <div className="relative flex-1 w-full">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search extensions..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-9 border-0 bg-transparent focus-visible:ring-0"
        />
      </div>
      <div className="h-6 w-px bg-border hidden sm:block" />
      <div className="flex items-center gap-2 w-full sm:w-auto px-2">
        <Filter className="h-3.5 w-3.5 text-muted-foreground" />
        <Select value={filterCategory} onValueChange={setFilterCategory}>
          <SelectTrigger className="w-[130px] h-8 border-0 bg-transparent focus:ring-0">
            <SelectValue placeholder="Category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Categories</SelectItem>
            {categories.map((c) => (
              <SelectItem key={c} value={c}>{c}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={filterStatus} onValueChange={(v) => setFilterStatus(v as FilterStatus)}>
          <SelectTrigger className="w-[130px] h-8 border-0 bg-transparent focus:ring-0">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="approved">Approved</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="rejected">Rejected</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
